import { useEffect, useState } from 'react';
import CreateAchievementPage from './CreateAchievementPage';
import { useParams } from 'react-router-dom';
import api, { AchievementDefinition } from '../../../api';
import { useSelector } from 'react-redux';
import { projectSelector } from '../../../redux/selectors/projectSelector';

type ParamsProps = {
	projectId: string;
	apiName: string;
};

export default function EditAchievementPage() {
	const [achievement, setAchievement] = useState<AchievementDefinition>();
	const apiName = useParams<ParamsProps>().apiName;
	const project = useSelector(projectSelector);
	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		const getAchievement = async () => {
			if (project?.productId) {
				setLoading(true);
				const achievement = await api
					.getAchievement(project.productId, apiName)
					.finally(() => {
						setLoading(false);
					});

				setAchievement(achievement);
			}
		};

		getAchievement();
	}, []);

	return <CreateAchievementPage achievement={achievement} loading={loading} />;
}
